export const OTP_LENGTH = 6;
